export default '1.8.2';



/** WEBPACK FOOTER **
 ** ./src/lib/version.js
 **/